// Global Instructions Rule Applied! - 2026-04-20

import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '../../Button.jsx'

const TOOLBAR_EXPORT_CLASS =
  '!border-0 !shadow-none !bg-transparent !text-white hover:!bg-white/10 hover:!text-white [&_.ant-btn-icon]:!text-white'

export interface ExportToolbarButtonProps {
  onClick: () => void | Promise<void>
  loading?: boolean
  disabled?: boolean
}

/**
 * Export control for the blue gradient ViewToolbar (matches Downloads SOI export styling).
 */
export default function ExportToolbarButton({ onClick, loading = false, disabled = false }: ExportToolbarButtonProps) {
  return (
    <Button
      variant='default'
      type='text'
      size='small'
      icon={<FontAwesomeIcon icon={faDownload} />}
      className={TOOLBAR_EXPORT_CLASS}
      onClick={() => {
        void onClick()
      }}
      loading={loading}
      disabled={disabled}
    >
      Export
    </Button>
  )
}
